module.exports = __webpack_public_path__ + "f0e99d03ef228b20435cb98fbc9b4bf0.pdf";